import React from 'react';
import './NotFound.css';
const NotFound = () => {
    return (
        <div className='body'>
            <div className="container">
                <div className="content py-5">
                    <h2>404</h2>
                    <h4>Oops! Page not found</h4>
                    <p>The page you were looking for doesn't exist. You may have mistyped the address or the page may have moved.</p>
                    <a href="/">Back To Home</a>
                </div>
            </div>
        </div>
    );
};

export default NotFound;